import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import TransferTicketModal from "../TransferTicketModal";
import InternalTicketsModal from "../InternalTicketsModal";
import TicketTagsModal from "../TicketTagsModal";
import toastError from "../../errors/toastError";
import { Can } from "../Can";
import { AuthContext } from "../../context/Auth/AuthContext";

const TicketOptionsMenu = ({
	ticket,
	menuOpen,
	handleClose,
	anchorEl,
	onRefreshTicket,
}) => {
	const history = useHistory();
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
	const [internalTicketsModalOpen, setInternalTicketsModalOpen] = useState(false);
	const [ticketTagsModalOpen, setTicketTagsModalOpen] = useState(false);
	const isMounted = useRef(true);
	const { user } = useContext(AuthContext);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	const handleDeleteTicket = async () => {
		try {
			await api.delete(`/tickets/${ticket.id}`);
			window.dispatchEvent(
				new CustomEvent("ticket:updated", {
					detail: { ticket: null, deletedTicketId: ticket.id }
				})
			);
			history.push("/tickets");
		} catch (err) {
			toastError(err);
		}
	};

	const handleOpenConfirmationModal = e => {
		setConfirmationOpen(true);
		handleClose();
	};

	const handleOpenTransferModal = e => {
		setTransferTicketModalOpen(true);
		handleClose();
	};

	const handleOpenInternalTicketsModal = () => {
		setInternalTicketsModalOpen(true);
		handleClose();
	};

	const handleOpenTicketTagsModal = () => {
		setTicketTagsModalOpen(true);
		handleClose();
	};

	const handleCloseTransferTicketModal = () => {
		if (isMounted.current) {
			setTransferTicketModalOpen(false);
		}
	};

	const handleCloseInternalTicketsModal = () => {
		if (isMounted.current) {
			setInternalTicketsModalOpen(false);
		}
	};

	const handleCloseTicketTagsModal = () => {
		if (isMounted.current) {
			setTicketTagsModalOpen(false);
		}
	};

	return (
		<>
			<Menu
				id="menu-appbar"
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				keepMounted
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				open={menuOpen}
				onClose={handleClose}
			>
				<MenuItem onClick={handleOpenInternalTicketsModal}>
					Tickets internos
				</MenuItem>
				<MenuItem onClick={handleOpenTicketTagsModal}>
					Tags
				</MenuItem>
				<MenuItem onClick={handleOpenTransferModal}>
					{i18n.t("ticketOptionsMenu.transfer")}
				</MenuItem>
				<Can
					role={user.profile}
					perform="ticket-options:deleteTicket"
					yes={() => (
						<MenuItem onClick={handleOpenConfirmationModal}>
							{i18n.t("ticketOptionsMenu.delete")}
						</MenuItem>
					)}
				/>
			</Menu>
			<ConfirmationModal
				title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")}${
					ticket.id
				} ${i18n.t("ticketOptionsMenu.confirmationModal.titleFrom")} ${
					ticket.contact.name
				}?`}
				open={confirmationOpen}
				onClose={setConfirmationOpen}
				onConfirm={handleDeleteTicket}
			>
				{i18n.t("ticketOptionsMenu.confirmationModal.message")}
			</ConfirmationModal>
			<TransferTicketModal
				modalOpen={transferTicketModalOpen}
				onClose={handleCloseTransferTicketModal}
				ticketid={ticket.id}
				ticketWhatsappId={ticket.whatsappId}
			/>
			<TicketTagsModal
				open={ticketTagsModalOpen}
				onClose={handleCloseTicketTagsModal}
				ticket={ticket}
				onSaved={onRefreshTicket}
			/>
			<InternalTicketsModal
				open={internalTicketsModalOpen}
				onClose={handleCloseInternalTicketsModal}
				ticketId={ticket.id}
				internalTickets={ticket.internalTickets || []}
				onRefresh={onRefreshTicket}
			/>
		</>
	);
};

export default TicketOptionsMenu;
